module.exports = __webpack_public_path__ + "img/companion-market-overview-category-filter.508a797d.png";